<template>
  <gj-modal
    :visible.sync="modalVisible"
    type="info"
    size="normal"
    notFooterPadding
    @cancel="cancel"
    @close="cancel"
    :confirm-loading="loading"
    @confirm="$emit('confirm')"
  >
    <template #header>
      <span>{{title}}</span>
    </template>
    <template #content>
      <div>
        <gj-text-alert type="warning">
          {{
            !(operatorRow.status.code === "ENABLE")
              ? "用户启用后可继续使用此账号登录系统，确认要启用吗？"
              : "用户停用后将不可再使用此账号登录系统，确认要停用吗？"
          }}
        </gj-text-alert>
      </div>
    </template>
  </gj-modal>
</template>
<script>
import { modalMixIn } from "../../../../../minxins";
export default {
  name: "user-handle-modal",
  mixins: [modalMixIn],
  props: {
    operatorRow: null,
    title:{
      type:String,
      default: '提示'
    }
  },
  data() {
    return {
      loading: false,
    };
  },
};
</script>
<style module lang="scss"></style>
